module.exports = __webpack_public_path__ + "h5/img/noSearch.50a8e221.png";